<script setup lang="ts">
/**
 * An avatar and two lines: the shape of every list row in this app —
 * a conversation, a notification, a contact, a comment.
 *
 * `lines` covers the rows that carry only a name, and `avatar="square"` the
 * ones whose subject is a page or a group rather than a person, which are
 * squircles everywhere else.
 */
import Skeleton from './Skeleton.vue';

withDefaults(
  defineProps<{ lines?: 1 | 2; avatar?: 'circle' | 'square' | 'none' }>(),
  { lines: 2, avatar: 'circle' },
);
</script>

<template>
  <div class="flex items-center gap-3 py-2">
    <Skeleton
      v-if="avatar !== 'none'"
      :shape="avatar === 'square' ? 'block' : 'circle'"
      class="h-10 w-10 shrink-0"
    />
    <div class="min-w-0 flex-1 space-y-2">
      <Skeleton class="h-3.5 w-1/2" />
      <Skeleton v-if="lines === 2" class="h-3 w-3/4" />
    </div>
  </div>
</template>
